;(function($, undefined){

    'use strict';

    var rnn = window.rnn;

    function buildInteractions(gallery, data){
        // we need to create an extra element in the galleria and insert existing elements into it.

        var $counterEl = $(gallery).find('.galleria-counter');

        $('<div class="galleria-details"></div>').insertBefore($counterEl);

        var $detailsEl = $(gallery).find('.galleria-details');
        $($counterEl).appendTo($detailsEl);

        var $infoEl = $(gallery).find('.galleria-info');
        $($infoEl).appendTo($detailsEl);

        // interaction to grow/shrink details of the photo.
        // we only want to engage this if there is info to show.
        if (data[0].description.length || data[0].title.length) {
            var baseHeight,
                expandedHeight;

            if (rnn.site.isDesktop === true) {
                baseHeight = '80px';
                expandedHeight = '150px';

                // Display comments by default for desktop only
                $('<i class="galleria-icon">&#xe800;</i>').appendTo($counterEl);
                $detailsEl.toggleClass('isExpanded');
            } else {
                baseHeight = '40px';
                expandedHeight = '100%';

                $('<i class="galleria-icon">&#xe801;</i>').appendTo($counterEl);
            }

            $counterEl.addClass('expandable');

            $counterEl.click(function() {
                if ($detailsEl.hasClass('isExpanded')) {
                    $detailsEl.stop().animate({
                        height: baseHeight
                    }, 200, function(){
                        $(gallery).find('.galleria-counter i').html('&#xe801;');
                    });
                } else {
                    $detailsEl.stop().animate({
                        height: expandedHeight
                    }, 200, function(){
                        $(gallery).find('.galleria-counter i').html('&#xe800;');
                    });
                }

                $detailsEl.toggleClass('isExpanded');
                return false;
            });
        }

        // full screen mode.
        var $stageEl = $(gallery).find('.galleria-stage');
        $('<div class="galleria-fullScrBtn"><i class="galleria-icon">&#xe817;</i></div>').appendTo($stageEl);

        $(gallery).find('.galleria-fullScrBtn').click(function() {
            $(gallery).data('galleria').toggleFullscreen();
        });

        // needs to move to the end of the container due to mobile device overlay issues.
        $detailsEl.insertAfter($(gallery).find('.galleria-fullScrBtn'));

        // set up new arrow icons.
        $(gallery).find('.galleria-image-nav-right').html('<i class="galleria-icon">&#xe816;</i>');
        $(gallery).find('.galleria-image-nav-left').html('<i class="galleria-icon">&#xe815;</i>');

        $(gallery).find('.galleria-thumb-nav-right').html('<i class="galleria-icon">&#xe812;</i>');
        $(gallery).find('.galleria-thumb-nav-left').html('<i class="galleria-icon">&#xe811;</i>');
    }

    function initGalleryInteractions(){
        // init
    }

    rnn.modules.register('galleryInteractions', {
        init: initGalleryInteractions,
        buildInteractions: buildInteractions
    });

})(jQuery);
